// Total spend detail (the burn / spend-breakdown view): spend over time, with
// an optional split into one usage/session-grain cohort line per facet value.
import { state, $, esc, usd, SR_PALETTE, get, autoBucket, windowQs, scopeQs, canCompareTeams } from '../core'
import { valueLineChart, stackChart, stackedBarChart, TEAM_COLORS } from '../charts'
import { spendBreakdownFacets, filterRowHtml, wireFacetFilters, facetFilterQs } from '../facets'

export function renderTotalSpend() {
  $('#metric-detail').innerHTML =
    '<div class="metric-head">' +
      '<h2>Total spend</h2>' +
    '</div>' +
    '<div class="panel">' +
      '<div class="sr-controls" id="sp-controls"></div>' +
      '<div id="sp-chart"></div>' +
      '<div class="sr-legend" id="sp-legend"></div>' +
      '<div class="card-note" id="sp-note"></div>' +
    '</div>';
  renderSpendControls();
  loadTotalSpend();
}

export function renderSpendControls() {
  var sp = state.spend;
  var activeBucket = autoBucket(sp.bucket);
  var bucketBtns = ['day', 'week', 'month'].map(function (b) {
    return '<button class="' + (b === activeBucket ? 'on' : '') + '" data-b="' + b + '">' + b + '</button>';
  }).join('');
  var byOpts = '<option value="">none</option>';
  var haveTeamFacet = false;
  spendBreakdownFacets().forEach(function (f) {
    if (f.key === 'team') haveTeamFacet = true;
    byOpts += '<option value="' + esc(f.key) + '"' + (f.key === sp.by ? ' selected' : '') + '>' + esc(f.label || f.key) + '</option>';
  });
  // `team` is NOT a facet — it is a DISJOINT ALLOCATION the server computes
  // (by=team: owner's team wins, repo fallback for teamless owners), so the
  // stacked segments partition the total exactly. Admin-only: for anyone else
  // the metric scope is clamped anyway, so the split would only mislead.
  if (!haveTeamFacet && canCompareTeams()) {
    byOpts += '<option value="team"' + (sp.by === 'team' ? ' selected' : '') + '>Team</option>';
  }
  $('#sp-controls').innerHTML =
    '<div class="sr-ctrl-row">' +
      filterRowHtml('sp', state.spend.filters) +
      '<span class="ctl-right">' +
        '<span class="seg" id="sp-bucket">' + bucketBtns + '</span>' +
        '<label class="sel-inline"><span>Break down</span><select class="sr-by" id="sp-by">' + byOpts + '</select></label>' +
      '</span></div>';
  wireFacetFilters('sp', $('#sp-controls'), state.spend.filters, renderSpendControls, loadTotalSpend);
  Array.prototype.forEach.call($('#sp-bucket').children, function (btn) {
    btn.onclick = function () { state.spend.bucket = btn.getAttribute('data-b'); renderSpendControls(); loadTotalSpend(); };
  });
  $('#sp-by').onchange = function () { state.spend.by = this.value; loadTotalSpend(); };
}


export function loadTotalSpend(topK?) {
  var sp = state.spend;
  // Hide, don't forget (same rule as the cost-artifact splits): while a user or
  // team filter hides the team option, sp.by KEEPS the choice and this loader
  // treats it as none — clearing the filter restores the split, never resets it.
  var effBy = sp.by === 'team' && !canCompareTeams() ? '' : sp.by;
  var qs = ['bucket=' + encodeURIComponent(autoBucket(sp.bucket))];
  if (effBy) qs.push('by=' + encodeURIComponent(effBy));
  if (topK) qs.push('topK=' + topK);
  var my = ++spReqId;
  var land = function (d) {
    if (my !== spReqId) return; // a later load owns the panel
    // The user may have opened another metric while the request was in flight —
    // the detail pane is then someone else's DOM, not a repaint target.
    if (!$('#sp-chart')) return;
    if (!d || d.error) {
      // Clear ALL three surfaces: leaving the previous window's legend (with
      // dollar totals) and note under an error chart presents stale figures
      // as if they described the failed window.
      $('#sp-chart').innerHTML = '<div class="empty">' + esc(d && d.error ? d.error : 'No data.') + '</div>';
      $('#sp-legend').innerHTML = '';
      $('#sp-note').innerHTML = '';
      return;
    }
    if (effBy === 'team') {
      // by=team is a DISJOINT ALLOCATION server-side (owner's team; a teamless
      // owner's session goes to the one team whose repos it touched), so the
      // segments partition the total and the stacked chart is exact — the
      // remainder renderSpend draws really is unallocated spend. Teams keep
      // their one hue everywhere (TEAM_COLORS by allTeams order).
      var teams = (state.filterOpts && state.filterOpts.allTeams) || [];
      var used = {};
      (d.series || []).forEach(function (sr) {
        for (var i = 0; i < teams.length; i++) {
          if (teams[i].name === sr.key) { sr.color = TEAM_COLORS[i % TEAM_COLORS.length]; break; }
        }
        if (sr.color) used[sr.color] = 1;
      });
      // A team the boot-time roster doesn't know (renamed/created since) must
      // not fall to renderSpend's generic palette — its first entry IS
      // TEAM_COLORS[0], which would paint two different teams one hue. Assign
      // the first UNUSED team hue instead.
      (d.series || []).forEach(function (sr) {
        if (sr.color) return;
        for (var j = 0; j < TEAM_COLORS.length; j++) {
          if (!used[TEAM_COLORS[j]]) { sr.color = TEAM_COLORS[j]; used[TEAM_COLORS[j]] = 1; break; }
        }
      });
      d.otherLabel = d.truncated ? 'other teams + teamless' : 'teamless';
      renderSpend(d);
      $('#sp-note').innerHTML = esc((d.series && d.series.length
        ? 'Every session is counted under exactly ONE team: its owner’s; a teamless owner’s session goes to the team whose repos it touched (grey when none, or several). The team filter shows a team’s wider reach — members plus repos — so a segment here can be smaller than that team’s filtered view.'
        : 'No spend allocated to any team in this window — it all belongs to teamless users.') +
        (d.truncated ? ' Showing the top ' + d.truncated.shown + ' of ' + d.truncated.total + ' teams by spend — the grey remainder also holds the rest.' : ''));
      return;
    }
    renderSpend(d);
  };
  get('/api/spend-over-time?' + qs.join('&') + windowQs() + scopeQs() + facetFilterQs(sp.filters)).then(land, function () { land(null); });
}

// Whichever load started last owns the panel — a slow straggler from a
// superseded mode can never repaint over the current one.
var spReqId = 0;

export function renderSpend(d) {
  var ov = d.overall || { total: 0, points: [] };
  if (d.series && d.series.length) {
    var series = d.series.map(function (s, i) {
      return {
        // A series may carry its own color (the team split pins TEAM_COLORS
        // so a team is the same hue on every page); facet series fall back to
        // the shared palette as before.
        label: s.key, color: s.color || SR_PALETTE[i % SR_PALETTE.length], total: s.total,
        points: s.points.map(function (p) { return { bucket: p.bucket, y: p.spend }; })
      };
    });
    if (d.presenceInflated) {
      // Multi-valued facet: a session's spend counts under several values, so the
      // components over-sum the total — stacking would lie. Keep cohort lines.
      $('#sp-chart').innerHTML = valueLineChart(d.buckets || [], series, 'usd');
      $('#sp-legend').innerHTML = spendLegend(series);
      var noteL = (d.truncated ? 'Showing top ' + d.truncated.shown + ' of ' + d.truncated.total + ' by spend. ' : '') +
        'Each line is one cohort. Sessions can carry several values here, so the lines sum to more than total spend.';
      $('#sp-note').innerHTML = esc(noteL);
    } else {
      // Components partition the bucket's spend → stack them. Add a muted "other"
      // segment for any top-K tail so the bars still reach the true total.
      var ovByB = {};
      (ov.points || []).forEach(function (p) { ovByB[p.bucket] = p.spend; });
      var shownByB = {};
      series.forEach(function (s) { s.points.forEach(function (p) { shownByB[p.bucket] = (shownByB[p.bucket] || 0) + p.y; }); });
      var otherPts = (d.buckets || []).map(function (b) { return { bucket: b, y: Math.max(0, (ovByB[b] || 0) - (shownByB[b] || 0)) }; });
      var otherTotal = otherPts.reduce(function (a, p) { return a + p.y; }, 0);
      var chart = series.slice();
      // The remainder segment: the facet path's anonymous top-K tail, or a real
      // population when the caller names it (the team split's "teamless").
      if (otherTotal > 0.005) chart.push({ label: d.otherLabel || 'other', color: '#cfc8b8', total: otherTotal, points: otherPts });
      $('#sp-chart').innerHTML = stackedBarChart(d.buckets || [], chart, 'usd');
      $('#sp-legend').innerHTML = spendLegend(chart);
      var noteB = (d.truncated ? 'Top ' + d.truncated.shown + ' of ' + d.truncated.total + '; the rest are grouped as “other”. ' : '') +
        'Each bar splits the bucket’s spend into components — hover a segment for its value.';
      $('#sp-note').innerHTML = esc(noteB);
    }
    if (d.truncated) {
      $('#sp-legend').innerHTML += ' <a class="show-all-link" data-total="' + d.truncated.total + '">Show all ' + d.truncated.total + '</a>';
      var spLink = $('#sp-legend .show-all-link');
      if (spLink) spLink.onclick = function () { loadTotalSpend(this.getAttribute('data-total')); };
    }
  } else {
    var barPts = (ov.points || []).map(function (p) { return { bucket: p.bucket, total: p.spend, filled: p.spend }; });
    $('#sp-chart').innerHTML = stackChart(d.buckets || [], barPts, 'usd');
    $('#sp-legend').innerHTML = '<span class="leg-overall">Total ' + esc(usd(ov.total)) + '</span>';
    $('#sp-note').innerHTML = esc('Spend per ' + autoBucket(state.spend.bucket) + ', dated at session start. Break down by a dimension to split it.');
  }
}

function spendLegend(series) {
  return series.map(function (l) {
    return '<span class="leg"><span class="swatch" style="background:' + l.color + '"></span>' + esc(l.label) +
      ' <span class="sr-cnt">' + usd(l.total) + '</span></span>';
  }).join('');
}
